export default "__VITE_ASSET__59420d21__"